"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerId = getCustomerId;
exports.setCurrencyMarketCookies = setCurrencyMarketCookies;
var _base = require("./base.functions");
var _domains = require("./domains");
var _traffic = require("./traffic");
/**
 * Set the Currency and Market cookies
 * @param {string} currency 3 letter currency code
 * @param {string} [market] Market
 * @returns {boolean} Returns true if the currency set correctly
 * @example setCurrencyMarketCookies('USD') => true
 * @example setCurrencyMarketCookies('USD', 'en-US') => true
 */
function setCurrencyMarketCookies(currency, market) {
  const {
    hostname
  } = window.location;
  const domain = (0, _domains.parseBaseDomain)(hostname);
  const oneYear = 365 * 24 * 60 * 60 * 1000; // in milliseconds
  const expires = new Date(Date.now() + oneYear).toUTCString();
  const currencyCookie = `currency=${currency}; domain=${domain}; path=/; expires=${expires}`;
  document.cookie = currencyCookie;
  if (market) {
    const marketCookie = `market=${market}; domain=${domain}; path=/; expires=${expires}`;
    document.cookie = marketCookie;
  }
  const currencySet = document.cookie.includes(`currency=${currency}`);
  const marketSet = document.cookie.includes(`market=${market}`);
  return market ? currencySet && marketSet : currencySet;
}

/**
 * Gets the current customer ID
 * @param {string} eid Element ID
 * @param {object} trafficEventProps Traffic event props objecrt
 * @returns {string} Customer ID
 */
function getCustomerId(eid, trafficEventProps) {
  const infoCustIDP = (0, _base.getCookieValue)('info_cust_idp');
  try {
    const decodedStr = decodeURIComponent(infoCustIDP);
    const parsedStr = JSON.parse(decodedStr);
    return parsedStr.info_cid;
  } catch (e) {
    (0, _traffic.logEvent)({
      eid: `${eid}.cid.error`,
      type: 'impression',
      properties: trafficEventProps
    });
    return '';
  }
}